import React from 'react';
import PropTypes from 'prop-types';
import { Price } from '../price';
import { getTranslationElement } from '../../../../helper/getTranslationElement';

export const ServiceWheelAlignment = ({
    wheelAlignmentQuantity,
    wheelAlignmentPrice,
    loading,
    onMoreInfoClick,
    currencyIsoCode,
}) => {
    const label = getTranslationElement(
        'pdp-sidebar-service-wheel-alignment-label',
        { wheelAlignmentQuantity },
        { onClick: onMoreInfoClick }
    );

    return (
        <Price
            name="service-wheel-alignment"
            label={label}
            price={wheelAlignmentPrice}
            currencyIsoCode={currencyIsoCode}
            isSub={true}
            loading={loading}
        />
    );
};

ServiceWheelAlignment.propTypes = {
    wheelAlignmentQuantity: PropTypes.number.isRequired,
    wheelAlignmentPrice: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    onMoreInfoClick: PropTypes.func.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
};
